// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section id="customer-deposit-accounts-cash-action" class="box product-operation">
  <sub-header header="'Choose amount to place'"></sub-header>
    <form-section>

      <div class="info info--deposit">
        <div class="info-detail">
          <span class="key">Product name:</span>
          <span class="value">
            {{\$ctrl.termDeposit.productName}}
          </span>
        </div>

        <div class="info-detail">
          <span class="key">Available balance:</span>
          <span class="value"
                ng-class="{'currency--positive': \$ctrl.termDeposit.balance > 0, 'currency--negative': \$ctrl.termDeposit.balance < 0}">
            {{\$ctrl.termDeposit.balance | nxCurrency}}
          </span>
        </div>

        <div class="info-detail">
          <span class="key">Outstanding placement fees:</span>
          <span class="value"
                ng-class="{'currency--positive': \$ctrl.termDeposit.placementFeeBalance < 0, 'currency--negative': \$ctrl.termDeposit.placementFeeBalance > 0}">
            {{\$ctrl.termDeposit.placementFeeBalance | nxCurrency}}
          </span>
        </div>
      </div>

      <cash-amount-picker
        values="[500, 1000, 1500, 2000, 2500, 5000, 10000]"
        inactive-button-class="'btn-success'"
        selected-button-class="'btn-primary'"
        on-select="\$ctrl.amountSelected(value)">
      </cash-amount-picker>

      <div class="buttons">
        <button class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
        <button class="btn btn-success" ng-click="\$ctrl.deposit()" ng-disabled="!\$ctrl.selectedAmount">Deposit</button>
      </div>

      <div class="clearfix"></div>
    </form-section>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/term-deposits/cash-placement/cash-placement.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;